"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: zod_1.z
        .string()
        .nullable()
        .describe("While financial statements likely are only at the org (borrower) level, it's possible we may need to support financials at the CF's SPV level too"),
    financialDataValueMap: finley_types_1.FinancialData.FinancialDataValueConfigurationMapSchema.describe('Financial data value configuration map'),
});
exports.nodeType = 'file_financialData';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    creditFacilitySlug: true,
});
// Every tape node must also export IntermediateRecord, as it describes
// the record that will be inserted into the database.
// (well not completely since it may be modified by synthetic node creation later)
// It includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'generatedFinancialData';
//# sourceMappingURL=types.js.map